import * as React from "react"

const RweBack = (props) => (
    <svg
        width={896}
        height={815}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 896 815`}
        {...props}
    >
        <path
            d="M378 479c20.435 0 37-16.565 37-37s-16.565-37-37-37-37 16.565-37 37 16.565 37 37 37Z"
            fill="#7209B7"
        />
        <path
            d="M441 439c18.778 0 34-15.222 34-34s-15.222-34-34-34-34 15.222-34 34 15.222 34 34 34Z"
            fill="#7209B7"
        />
        <path
            d="M453 478c17.673 0 32-14.327 32-32 0-17.673-14.327-32-32-32-17.673 0-32 14.327-32 32 0 17.673 14.327 32 32 32Z"
            fill="#951E83"
        />
        <path
            d="M415 513c19.33 0 35-15.67 35-35s-15.67-35-35-35-35 15.67-35 35 15.67 35 35 35Z"
            fill="#A51991"
        />
        <path
            d="M380 418c16.569 0 30-13.431 30-30 0-16.569-13.431-30-30-30-16.569 0-30 13.431-30 30 0 16.569 13.431 30 30 30Z"
            fill="#7209B7"
        />
        <path d="M458 308a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z" fill="#B5179E" />
    </svg>
)

export default RweBack
